var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',_vm._l((_vm.searchedFbaProducts),function(searchedFbaProduct){return _c('SearchedFbaProduct',{key:searchedFbaProduct.id,attrs:{"searched-fba-product":searchedFbaProduct}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }